import './Sobre.css';
import ImageTitle from "../../components/ImageTitle";
import imageFora from '../../assets/imagensFora/fotoFora.jpg';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

function Sobre() {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const element = document.getElementById(location.hash.replace('#', ''));
      if (element) element.scrollIntoView({ behavior: 'smooth' });
    }
  }, [location]);

  return (
    <div className="container-fluid p-0">
      <ImageTitle titulo="Nossa História" disableButton={true} />

      <div className="container my-5 py-5">
        <div className="title-section">
          <div className="title-tag"></div>
          <h2 className="title-text">Como tudo começou...</h2>
        </div>
        
        <div className="row mt-4 align-items-center gy-5">
          <div className="col-12 col-lg-6 pr-lg-5 about-text">
            <p className="lead text-dark">Há mais de 30 anos conhecemos Santo Hilário e nos apaixonamos à primeira vista.</p>
            <p>Com o tempo, amadureceu a ideia de nos estabelecer aqui. Em 2018, surgiu o desejo de construir uma pousada e um restaurante, que logo se transformou em um sonho. Em 2019, demos início à obra para proporcionar a mais pessoas a oportunidade de desfrutar deste lugar maravilhoso.</p>
            <p>Durante esses seis anos, enfrentamos obstáculos, mas nunca desistimos. Em 2025 o sonho se torna realidade. A pousada está pronta para receber hóspedes que já conhecem e amam Santo Hilário, assim como aqueles que irão se encantar pela primeira vez.</p>
          </div>
          <div className="col-12 col-lg-6 text-center">
            <img src={imageFora} className="img-fluid about-img shadow-lg" alt="Villa Capetinga" />
          </div>
        </div>

        {/* Seção da Feira Gastronômica */}
        <div className="title-section mt-5 pt-5" id="sobre-feira">
          <div className="title-tag"></div>
          <h2 className="title-text">Sobre a Feira Gastronômica</h2>
        </div>
        
        <div className="info-card mt-4 p-4 p-md-5">
          <p>A feira acontece todo segundo sábado de cada mês em Santo Hilário. É um evento imperdível com show ao vivo na praça e diversas barraquinhas oferecendo o melhor da gastronomia local.</p>
          
          <ul className="info-list mt-4">
            <li><i className="bi bi-calendar-event text-gold"></i> <strong>Data:</strong> Todo 2º Sábado do mês</li>
            <li><i className="bi bi-clock text-gold"></i> <strong>Horário:</strong> Das 16h às 22h</li>
            <li><i className="bi bi-geo-alt text-gold"></i> <strong>Local:</strong> Praça de Santo Hilário - MG</li>
          </ul>
        </div>
      </div>
    </div>
  );
}

export default Sobre;